import React from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export const AdminClaimButton: React.FC = () => {
  const handleSetAdminClaim = async () => {
    try {
      console.log('🔧 Setting admin claims...');
      
      // Call the setAdminClaim function
      const setAdminClaim = httpsCallable(functions, 'setAdminClaim');
      const result = await setAdminClaim();
      
      console.log('✅ Success:', result.data);
      alert('Admin claims set successfully! Please log out and log back in.');
      
      // Optionally reload to apply changes
      if (window.confirm('Log out now to apply changes?')) {
        window.location.reload();
      }
      
    } catch (error: any) {
      console.error('❌ Error setting admin claims:', error);
      
      if (error.code === 'permission-denied') {
        alert('Permission denied. Your user ID might not be in the allowed list.');
      } else if (error.code === 'unauthenticated') {
        alert('Please make sure you are logged in first.');
      } else if (error.code === 'functions/not-found') {
        alert('Admin function not found. It might still be deploying.');
      } else {
        alert('Error setting admin claims. Check console for details.');
      }
    }
  };

  return (
    <button 
      onClick={handleSetAdminClaim}
      style={{
        backgroundColor: '#ff6b35',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 'bold'
      }}
    >
      🛡️ Set Admin Claims
    </button>
  );
};
